import { IconButton } from "../../../controls/TooltipControls";
import { ComponentEx, translate } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { truthy } from "../../../util/util";
import { setModEnabled } from "../actions/profiles";
import { closeDialog } from "../actions/transferSetup";
import * as React from "react";
import { Button, Checkbox, FormControl, Modal } from "react-bootstrap";
import { connect } from "react-redux";
/**
 * simple dialog to set userlist rule between two plugins
 *
 * @class Editor
 * @extends {ComponentEx<IProps, IComponentState>}
 */
class Editor extends ComponentEx {
    constructor(props) {
        super(props);
        this.initState({
            dialog: undefined,
            transferEnabledMods: true,
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.dialog !== this.props.dialog) {
            this.nextState.dialog = nextProps.dialog;
        }
    }
    render() {
        const { t, profiles } = this.props;
        const { dialog } = this.state;
        return (React.createElement(Modal, { show: truthy(dialog), onHide: this.close },
            truthy(dialog) ? (React.createElement(Modal.Body, null,
                React.createElement("div", null,
                    React.createElement(FormControl.Static, null, t("From: {{source}}", {
                        replace: { source: profiles[dialog.source].name },
                    })),
                    React.createElement(IconButton, { id: "btn-swap-profiles", icon: "swap", tooltip: t("Swap profiles"), onClick: this.swapProfiles }),
                    React.createElement(FormControl.Static, null, t("To: {{target}}", {
                        replace: { target: profiles[dialog.target].name },
                    }))),
                React.createElement(Checkbox, { checked: this.state.transferEnabledMods, onChange: this.toggleTransferEnabled }, t("Transfer Enabled Mods")))) : null,
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.close }, t("Cancel")),
                React.createElement(Button, { onClick: this.apply }, t("Transfer")))));
    }
    swapProfiles = () => {
        const temp = this.nextState.dialog.source;
        this.nextState.dialog.source = this.nextState.dialog.target;
        this.nextState.dialog.target = temp;
    };
    toggleTransferEnabled = () => {
        this.nextState.transferEnabledMods = !this.state.transferEnabledMods;
    };
    apply = () => {
        const { mods, onSetModEnabled, profiles } = this.props;
        const { dialog } = this.state;
        Object.keys(mods || {}).forEach((modId) => {
            onSetModEnabled(dialog.target, modId, getSafe(profiles, [dialog.source, "modState", modId, "enabled"], false));
        });
        this.close();
    };
    close = () => {
        this.props.onCloseDialog();
    };
}
function mapStateToProps(state) {
    const dialog = state.session.profileTransfer.dialog || undefined;
    return {
        dialog,
        profiles: state.persistent.profiles,
        mods: truthy(dialog) ? state.persistent.mods[dialog.gameId] : undefined,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onCloseDialog: () => dispatch(closeDialog()),
        onSetModEnabled: (profileId, modId, enabled) => dispatch(setModEnabled(profileId, modId, enabled)),
    };
}
export default translate(["common", "profile-management"])(connect(mapStateToProps, mapDispatchToProps)(Editor));
